const isStage = document.location.host.endsWith('tabby.dev');
const isDevelopment = process.env.NODE_ENV === 'development';

export const MERCHANT_LIST_FOR_FINGERPRONT = [
  'https://3saf.com',
  'https://laverne.com',
  isStage || isDevelopment ? 'tabby-qa-test' : null,
].filter(Boolean);
